var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('v-server-table',{ref:"datatable",attrs:{"url":_vm.api,"name":_vm.tableName,"columns":_vm.columns,"options":_vm.options}}),_vm._v(" "),_c('vuetablemodifier_form',{ref:"modifierSetsForm",on:{"modifierset-saved":_vm.refresh}})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1205e946","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/franchise_component/inventory/modifier/vuetable_modifier.vue
// module id = 3pxt
// module chunks = 99